/**
 * Canonical user role names (mirror backend/roles.py).
 *
 * Role names are UPPER_SNAKE_CASE: capital letters and digits separated by
 * single underscores. Prefer capability checks from `permissions.ts` over role
 * checks; these constants exist for the few places that must match a role.
 */
export const ROLE = {
  ADMIN: 'ADMIN',
  PM: 'PM',
  LEAD: 'LEAD',
  ENG: 'ENG',
  HR: 'HR',
  RECRUITER: 'RECRUITER',
  DOCUMENT_CONTROLLER: 'DOCUMENT_CONTROLLER',
  DIRECTOR: 'DIRECTOR',
  SALES: 'SALES',
  INTERN: 'INTERN',
  EXTERN: 'EXTERN',
} as const;

export const ROLE_NAME_MAX_LENGTH = 50;
export const ROLE_NAME_PATTERN = /^[A-Z][A-Z0-9]*(_[A-Z0-9]+)*$/;

export const ROLE_NAME_RULE =
  'Use UPPER_SNAKE_CASE: capital letters and digits separated by single ' +
  'underscores (e.g. DOCUMENT_CONTROLLER)';

/** Coerce a typed role name to UPPER_SNAKE_CASE, collapsing separators. */
export function normalizeRoleName(name: string): string {
  return name.trim().replace(/[\s_-]+/g, '_').replace(/^_+|_+$/g, '').toUpperCase();
}

/** Return an error message if the name breaks the convention, else null. */
export function validateRoleName(name: string): string | null {
  if (!name) return 'Role name is required';
  if (name.length > ROLE_NAME_MAX_LENGTH) {
    return `Role name must be at most ${ROLE_NAME_MAX_LENGTH} characters`;
  }
  if (!ROLE_NAME_PATTERN.test(name)) return ROLE_NAME_RULE;
  return null;
}
